import Vue from 'vue'
import Meta from 'vue-meta'
import ClientOnly from 'vue-client-only'
import NoSsr from 'vue-no-ssr'
import { createRouter } from './router.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from '..\\layouts\\error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'
import { createStore } from './store.js'

/* Plugins */

import nuxt_plugin_plugin_0eb7c540 from 'nuxt_plugin_plugin_0eb7c540' // Source: .\\vuetify\\plugin.js (mode: 'all')
import nuxt_plugin_sentryserver_88d803ca from 'nuxt_plugin_sentryserver_88d803ca' // Source: .\\sentry.server.js (mode: 'server')
import nuxt_plugin_sentryclient_55da8c93 from 'nuxt_plugin_sentryclient_55da8c93' // Source: .\\sentry.client.js (mode: 'client')
import nuxt_plugin_gtm_52b5b5ed from 'nuxt_plugin_gtm_52b5b5ed' // Source: .\\gtm.js (mode: 'all')
import nuxt_plugin_cookieuniversalnuxt_1b80d202 from 'nuxt_plugin_cookieuniversalnuxt_1b80d202' // Source: .\\cookie-universal-nuxt.js (mode: 'all')
import nuxt_plugin_plugin_288a5b69 from 'nuxt_plugin_plugin_288a5b69' // Source: .\\gpt-ads-module\\plugin.js (mode: 'all')
import nuxt_plugin_toast_ad345bf4 from 'nuxt_plugin_toast_ad345bf4' // Source: .\\toast.js (mode: 'client')
import nuxt_plugin_axios_4594f552 from 'nuxt_plugin_axios_4594f552' // Source: .\\axios.js (mode: 'all')
import nuxt_plugin_redisRepositories_50a359cd from 'nuxt_plugin_redisRepositories_50a359cd' // Source: ..\\plugins\\redisRepositories (mode: 'all')
import nuxt_plugin_axios_3566aa80 from 'nuxt_plugin_axios_3566aa80' // Source: ..\\plugins\\axios (mode: 'all')
import nuxt_plugin_error_34fb1f5c from 'nuxt_plugin_error_34fb1f5c' // Source: ..\\plugins\\error (mode: 'all')
import nuxt_plugin_mixinGlobal_a372d364 from 'nuxt_plugin_mixinGlobal_a372d364' // Source: ..\\plugins\\mixinGlobal (mode: 'all')
import nuxt_plugin_bus_5e46274a from 'nuxt_plugin_bus_5e46274a' // Source: ..\\plugins\\bus (mode: 'all')
import nuxt_plugin_ssa_5e4666cb from 'nuxt_plugin_ssa_5e4666cb' // Source: ..\\plugins\\ssa (mode: 'client')
import nuxt_plugin_vuesocialsharing_dccf00ce from 'nuxt_plugin_vuesocialsharing_dccf00ce' // Source: ..\\plugins\\vue-social-sharing (mode: 'client')
import nuxt_plugin_vuetour_9db5e896 from 'nuxt_plugin_vuetour_9db5e896' // Source: ..\\plugins\\vue-tour (mode: 'client')
import nuxt_plugin_googlemaps_ab35f716 from 'nuxt_plugin_googlemaps_ab35f716' // Source: ..\\plugins\\google-maps (mode: 'client')
import nuxt_plugin_plugin_b4a85074 from 'nuxt_plugin_plugin_b4a85074' // Source: .\\auth\\plugin.js (mode: 'all')
import nuxt_plugin_auth_7f7561ce from 'nuxt_plugin_auth_7f7561ce' // Source: ..\\plugins\\auth.js (mode: 'all')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly)

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, {
  ...NoSsr,
  render (h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true

      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead')
    }
    return NoSsr.render(h, ctx)
  }
})

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt)

Vue.use(Meta, {"keyName":"head","attribute":"data-n-head","ssrAttribute":"data-n-head-ssr","tagIDKeyName":"hid"})

async function createApp(ssrContext, config = {}) {
  const router = await createRouter(ssrContext)

  const store = createStore(ssrContext)
  // Add this.$router into store actions/mutations
  store.$router = router

  // Fix SSR caveat https://github.com/nuxt/nuxt.js/issues/3757#issuecomment-414689141
  const registerModule = store.registerModule
  store.registerModule = (path, rawModule, options) => registerModule.call(store, path, rawModule, Object.assign({ preserveState: process.client }, options))

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    head: {"title":"דרושים IL- חיפוש עבודה בחינם, גיוס עובדים","meta":[{"http-equiv":"Content-Type","content":"text\u002Fhtml; charset=utf-8"},{"http-equiv":"Content-Language","content":"he"},{"name":"viewport","content":"width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no,viewport-fit=cover"},{"name":"author","content":"דרושים IL","hid":"author"},{"name":"copyright","content":"דרושים IL, 2014","hid":"COPYRIGHT"},{"name":"Author","content":"דרושים - https:\u002F\u002Fwww.drushim.co.il\u002F","hid":"AUTHOR"},{"name":"Generator","content":"דרושים - https:\u002F\u002Fwww.drushim.co.il\u002F","hid":"GENERATOR"},{"name":"keywords","content":"דרושים, לוח דרושים, עבודה, חיפוש עבודה, משרות, מודעות דרושים, דרושים הייטק, עבודה בחול, גיוס עובדים, פרסום מודעות דרושים.","hid":"KEYWORDS"},{"name":"description","content":"דרושים IL הוא לוח דרושים האיכותי בישראל. האתר מאפשר חיפוש עבודה חינם וכן גיוס עובדים באופן מהיר וידידותי עם אלפי משרות. בנוסף, באתר איזור דרושים הייטק.","hid":"DESCRIPTION"},{"name":"ROBOTS","content":"INDEX, FOLLOW","hid":"ROBOTS"}],"link":[{"rel":"icon","type":"image\u002Fx-icon","href":"\u002Ffavicon.ico"},{"rel":"preconnect","href":"https:\u002F\u002Ffonts.googleapis.com"},{"rel":"preconnect","href":"https:\u002F\u002Ffonts.gstatic.com"},{"rel":"stylesheet","href":"https:\u002F\u002Ffonts.googleapis.com\u002Fcss2?family=Rubik:wght@400;500&display=swap"},{"rel":"stylesheet","type":"text\u002Fcss","href":"https:\u002F\u002Ffonts.googleapis.com\u002Fcss?family=Roboto:100,300,400,500,700,900&display=swap"},{"rel":"stylesheet","type":"text\u002Fcss","href":"https:\u002F\u002Fcdn.jsdelivr.net\u002Fnpm\u002F@mdi\u002Ffont@latest\u002Fcss\u002Fmaterialdesignicons.min.css"}],"script":[{"type":"text\u002Fjavascript","id":"braze-integrator","src":"https:\u002F\u002Fexported-appliction.yad2.co.il\u002Fprod\u002Fbraze-script-integrator\u002Fentry-points\u002Fdrushim-seeker.js","defer":true,"async":true},{"type":"application\u002Fld+json","id":"organization-structure-data","src":"https:\u002F\u002Fwww.drushim.co.il\u002Fseo\u002Forganization-structure-data.json","defer":true,"async":true},{"hid":"gtm-script","innerHTML":"if(!window._gtm_init){window._gtm_init=1;(function (w,n,d,m,e,p){w[d]=(w[d]==1||n[d]=='yes'||n[d]==1||n[m]==1||(w[e]&&w[e][p]&&w[e][p]()))?1:0})(window,navigator,'doNotTrack','msDoNotTrack','external','msTrackingProtectionEnabled');(function(w,d,s,l,x,y){w[x]={};w._gtm_inject=function(i){if(w.doNotTrack||w[x][i])return;w[x][i]=1;w[l]=w[l]||[];w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],j=d.createElement(s);j.async=true;j.src='https:\u002F\u002Fwww.googletagmanager.com\u002Fgtm.js?id='+i;f.parentNode.insertBefore(j,f);};w[y]('GTM-526CVM')})(window,document,'script','dataLayer','_gtm_ids','_gtm_inject')}"}],"style":[],"noscript":[{"hid":"gtm-noscript","pbody":true,"innerHTML":"\u003Ciframe src=\"https:\u002F\u002Fwww.googletagmanager.com\u002Fns.html?id=GTM-526CVM&\" height=\"0\" width=\"0\" style=\"display:none;visibility:hidden\" title=\"gtm\"\u003E\u003C\u002Fiframe\u003E"}],"__dangerouslyDisableSanitizersByTagID":{"gtm-script":["innerHTML"],"gtm-noscript":["innerHTML"]}},

    store,
    router,
    nuxt: {
      err: null,
      dateErr: null,
      error (err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        let nuxt = app.nuxt // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
        if (this) {
          nuxt = this.nuxt || this.$options.nuxt
        }
        nuxt.dateErr = Date.now()
        nuxt.err = err
        // Used in src/server.js
        if (ssrContext) {
          ssrContext.nuxt.error = err
        }
        return err
      }
    },
    ...App
  }

  // Make app available into store via this.app
  store.app = app

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base, router.options.mode)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    store,
    route,
    next,
    error: app.nuxt.error.bind(app),
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    ssrContext
  })

  function inject(key, value) {
    if (!key) {
      throw new Error('inject(key, value) has no key provided')
    }
    if (value === undefined) {
      throw new Error(`inject('${key}', value) has no value provided`)
    }

    key = '$' + key
    // Add into app
    app[key] = value
    // Add into context
    if (!app.context[key]) {
      app.context[key] = value
    }

    // Add into store
    store[key] = app[key]

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) {
      return
    }
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Object.prototype.hasOwnProperty.call(Vue.prototype, key)) {
        Object.defineProperty(Vue.prototype, key, {
          get () {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  // Inject runtime config as $config
  inject('config', config)

  if (process.client) {
    // Replace store state before plugins execution
    if (window.__NUXT__ && window.__NUXT__.state) {
      store.replaceState(window.__NUXT__.state)
    }
  }

  // Add enablePreview(previewData = {}) in context for plugins
  if (process.static && process.client) {
    app.context.enablePreview = function (previewData = {}) {
      app.previewData = Object.assign({}, previewData)
      inject('preview', previewData)
    }
  }
  // Plugin execution

  if (typeof nuxt_plugin_plugin_0eb7c540 === 'function') {
    await nuxt_plugin_plugin_0eb7c540(app.context, inject)
  }

  if (process.server && typeof nuxt_plugin_sentryserver_88d803ca === 'function') {
    await nuxt_plugin_sentryserver_88d803ca(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_sentryclient_55da8c93 === 'function') {
    await nuxt_plugin_sentryclient_55da8c93(app.context, inject)
  }

  if (typeof nuxt_plugin_gtm_52b5b5ed === 'function') {
    await nuxt_plugin_gtm_52b5b5ed(app.context, inject)
  }

  if (typeof nuxt_plugin_cookieuniversalnuxt_1b80d202 === 'function') {
    await nuxt_plugin_cookieuniversalnuxt_1b80d202(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin_288a5b69 === 'function') {
    await nuxt_plugin_plugin_288a5b69(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_toast_ad345bf4 === 'function') {
    await nuxt_plugin_toast_ad345bf4(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_4594f552 === 'function') {
    await nuxt_plugin_axios_4594f552(app.context, inject)
  }

  if (typeof nuxt_plugin_redisRepositories_50a359cd === 'function') {
    await nuxt_plugin_redisRepositories_50a359cd(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_3566aa80 === 'function') {
    await nuxt_plugin_axios_3566aa80(app.context, inject)
  }

  if (typeof nuxt_plugin_error_34fb1f5c === 'function') {
    await nuxt_plugin_error_34fb1f5c(app.context, inject)
  }

  if (typeof nuxt_plugin_mixinGlobal_a372d364 === 'function') {
    await nuxt_plugin_mixinGlobal_a372d364(app.context, inject)
  }

  if (typeof nuxt_plugin_bus_5e46274a === 'function') {
    await nuxt_plugin_bus_5e46274a(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_ssa_5e4666cb === 'function') {
    await nuxt_plugin_ssa_5e4666cb(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vuesocialsharing_dccf00ce === 'function') {
    await nuxt_plugin_vuesocialsharing_dccf00ce(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vuetour_9db5e896 === 'function') {
    await nuxt_plugin_vuetour_9db5e896(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_googlemaps_ab35f716 === 'function') {
    await nuxt_plugin_googlemaps_ab35f716(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin_b4a85074 === 'function') {
    await nuxt_plugin_plugin_b4a85074(app.context, inject)
  }

  if (typeof nuxt_plugin_auth_7f7561ce === 'function') {
    await nuxt_plugin_auth_7f7561ce(app.context, inject)
  }

  // Lock enablePreview in context
  if (process.static && process.client) {
    app.context.enablePreview = function () {
      console.warn('You cannot call enablePreview() outside a plugin.')
    }
  }

  // If server-side, wait for async component to be resolved first
  if (process.server && ssrContext && ssrContext.url) {
    await new Promise((resolve, reject) => {
      router.push(ssrContext.url, resolve, () => {
        // navigated to a different route in router guard
        const unregister = router.afterEach(async (to, from, next) => {
          ssrContext.url = to.fullPath
          app.context.route = await getRouteData(to)
          app.context.params = to.params || {}
          app.context.query = to.query || {}
          unregister()
          resolve()
        })
      })
    })
  }

  return {
    store,
    app,
    router
  }
}

export { createApp, NuxtError }
